import React from 'react';

const RentalTerms = () => (
  <div className="max-w-3xl mx-auto px-4 py-10">
    <h1 className="text-3xl font-bold text-pink-700 mb-6">Rental Terms & Conditions</h1>
    <div className="space-y-6 text-gray-800 text-base">
      <section>
        <h2 className="text-xl font-semibold mb-2">1. Rental Agreement</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>This is a rental service. Items are provided for temporary use only and remain the property of theVastra.store.</li>
          <li>A security deposit may be required, which is refundable upon return inspection.</li>
          <li>The item must be returned in the same condition as delivered. Any damage, stains, or loss may result in a deduction from the security deposit or additional charges.</li>
          <li>Late returns may incur a daily penalty as per our rental policy.</li>
          <li>All items are dry-cleaned and sanitized before dispatch.</li>
          <li>Rental bookings are non-refundable once confirmed. Rescheduling is allowed based on availability.</li>
          <li>By placing a rental order, you agree to these Rental Terms & Conditions.</li>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-2">2. Privacy Policy for Rental Customers</h2>
        <p className="mb-2 text-gray-700">We value your privacy. This policy explains how we collect, use, and protect your information for rental orders:</p>
        <section className="mb-6">
          <h3 className="text-lg font-bold text-pink-600 mb-2">What Data We Collect</h3>
          <ul className="list-disc pl-8 space-y-2 text-gray-800">
            <li className="marker:text-pink-500">Personal information (name, email, phone, address) for order processing and support.</li>
            <li className="marker:text-pink-500">Order and payment details.</li>
            <li className="marker:text-pink-500">Usage data (pages visited, device info, etc.).</li>
          </ul>
        </section>
        <section className="mb-6">
          <h3 className="text-lg font-bold text-pink-600 mb-2">How We Use Your Data</h3>
          <ul className="list-disc pl-8 space-y-2 text-gray-800">
            <li className="marker:text-pink-500">To process orders and provide customer support.</li>
            <li className="marker:text-pink-500">To improve our website and services.</li>
            <li className="marker:text-pink-500">To send order updates, offers, and important notifications.</li>
          </ul>
        </section>
        <section className="mb-6">
          <h3 className="text-lg font-bold text-pink-600 mb-2">Cookies & Tracking</h3>
          <ul className="list-disc pl-8 space-y-2 text-gray-800">
            <li className="marker:text-pink-500">We use cookies to enhance your browsing experience and analyze site traffic.</li>
            <li className="marker:text-pink-500">You can disable cookies in your browser settings, but some features may not work.</li>
          </ul>
        </section>
        <section className="mb-6">
          <h3 className="text-lg font-bold text-pink-600 mb-2">Data Security</h3>
          <ul className="list-disc pl-8 space-y-2 text-gray-800">
            <li className="marker:text-pink-500">We use secure methods to store and transmit your data.</li>
            <li className="marker:text-pink-500">Access to your data is restricted to authorized personnel only.</li>
          </ul>
        </section>
        <section className="mb-6">
          <h3 className="text-lg font-bold text-pink-600 mb-2">Your Rights</h3>
          <ul className="list-disc pl-8 space-y-2 text-gray-800">
            <li className="marker:text-pink-500">You can request access, correction, or deletion of your personal data at any time.</li>
            <li className="marker:text-pink-500">Contact us at <a href='mailto:thevastra.store1999@gmail.com' className='text-indigo-600 underline'>thevastra.store1999@gmail.com</a> for privacy requests.</li>
          </ul>
        </section>
        <section className="mb-8">
          <h3 className="text-lg font-bold text-pink-600 mb-2">Third-Party Services</h3>
          <ul className="list-disc pl-8 space-y-2 text-gray-800">
            <li className="marker:text-pink-500">We may use third-party services (e.g., payment gateways, analytics) that have their own privacy policies.</li>
          </ul>
        </section>
        <div className="text-right text-sm text-gray-500">Last updated: July 2024</div>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-2">3. Customer Responsibilities</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Inspect the item upon delivery and report any issues immediately.</li>
          <li>Return the item by the agreed date in the same condition as received.</li>
          <li>Contact us promptly if you need to reschedule or extend your rental period (subject to availability).</li>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-2">4. Contact & Support</h2>
        <p>For any questions or concerns about your rental, please contact our support team at <a href="mailto:support@thevastra.store" className="underline text-pink-600">support@thevastra.store</a>.</p>
      </section>
    </div>
  </div>
);

export default RentalTerms; 